var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconBusinessCard = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64.37 42.59",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1d1d1b",
    d: "M49.33 22.34c.94-.96 1.52-2.27 1.52-3.72v-2.67c0-2.94-2.39-5.33-5.33-5.33s-5.33 2.39-5.33 5.33v2.67c0 1.45.58 2.76 1.52 3.72-3.06 1.66-5.52 5.03-5.52 8.28a1.33 1.33 0 1 0 2.66 0c0-3.36 3.8-6.65 6.65-6.67h.04c2.85 0 6.65 3.3 6.65 6.67a1.33 1.33 0 1 0 2.66 0c0-3.25-2.46-6.62-5.52-8.28Zm-6.48-3.72v-2.67c0-1.47 1.2-2.67 2.67-2.67s2.67 1.2 2.67 2.67v2.67c0 1.46-1.19 2.66-2.65 2.67h-.04c-1.46 0-2.65-1.2-2.65-2.67ZM9.52 13.29h16a1.33 1.33 0 1 0 0-2.66h-16a1.33 1.33 0 1 0 0 2.66ZM9.52 18.62h10.67a1.33 1.33 0 1 0 0-2.66H9.52a1.33 1.33 0 1 0 0 2.66ZM9.52 31.96h16a1.33 1.33 0 1 0 0-2.66h-16a1.33 1.33 0 1 0 0 2.66ZM9.52 26.62h10.67a1.33 1.33 0 1 0 0-2.66H9.52a1.33 1.33 0 1 0 0 2.66Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1d1d1b",
    d: "M60.96 42.59H3.42C1.53 42.59 0 41.05 0 39.17V3.42C0 1.53 1.54 0 3.42 0h57.53c1.89 0 3.42 1.54 3.42 3.42v35.75c0 1.89-1.54 3.42-3.42 3.42h.01ZM3.42 2.99c-.23 0-.42.19-.42.42v35.75c0 .23.19.42.42.42h57.53c.23 0 .42-.19.42-.42V3.42c0-.23-.19-.42-.42-.42H3.42Z"
  })));
};
export default SvgIconBusinessCard;